export default __webpack_public_path__ + "static/media/coronavirus-icon.6a06b055.svg";